import React from 'react'
import { StyledChatHeader } from './ChatHeader.style';
import Skeleton from 'react-loading-skeleton';


const ChatHeaderSkeleton = () => {
  return (
    <StyledChatHeader className='chat-header'>
      <div className='chat-header__img-wrapper'>
        <span></span>
      </div>
      <div className='chat-header__text-wrapper'>
        <h5 className='chat-header__title'>
          <Skeleton count={1} height={18} width={'35%'}/>
        </h5>
        <p className='chat-header__description'>
          <Skeleton count={1} height={18} width={'85%'}/>
        </p>
      </div>
    </StyledChatHeader>
  )
}

export default ChatHeaderSkeleton;
